import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import ErrorBoundary from "@/components/ErrorBoundary";

// Layout Components
import Layout from "@/components/layout/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

// Public Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CommitteesPage from "@/pages/CommitteesPage";
import VenuePage from "@/pages/VenuePage";
import ApplyPage from "@/pages/ApplyPage";
import ContactPage from "@/pages/ContactPage";

// Admin Pages
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminApplications from "@/pages/admin/AdminApplications";

/**
 * App Component
 * - Single BrowserRouter
 * - Public routes wrapped in Layout
 * - Admin routes use ProtectedRoute + AdminLayout via Outlet pattern
 */
function App() {
    return (
        <ErrorBoundary>
            <LanguageProvider>
                <BrowserRouter>
                    <Routes>

                        {/* ================= PUBLIC ROUTES ================= */}
                        <Route element={<Layout />}>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/committees" element={<CommitteesPage />} />
                            <Route path="/venue" element={<VenuePage />} />
                            <Route path="/apply" element={<ApplyPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                        </Route>

                        {/* ================= ADMIN LOGIN ================= */}
                        <Route path="/admin/login" element={<AdminLoginPage />} />

                        {/* ================= ADMIN PROTECTED ================= */}
                        <Route path="/admin" element={<ProtectedRoute />}>
                            <Route element={<AdminLayout />}>
                                <Route index element={<AdminDashboard />} />
                                <Route path="applications" element={<AdminApplications />} />
                            </Route>
                        </Route>

                    </Routes>

                    {/* Toast Notifications */}
                    <Toaster position="top-right" richColors />
                </BrowserRouter>
            </LanguageProvider>
        </ErrorBoundary>
    );
}

export default App;